<h1>Add additional items</h1>
<p>Please select additional items to apply changes to:</p>
<div class="checkbox-list">
  Items Selected: {{ itemsSelected }}
  <div class="header">
    <mat-checkbox [(ngModel)]="selectAll" (change)="selectAllItems()" class="checkbox"></mat-checkbox>
    <div class="cin">Item No.</div>
    <div class="name">Item Name</div>
    <div class="description">Item Description</div>
    <div class="lead-time">Lead Time</div>
    <div class="prep-time">Prep Time</div>
  </div>
  <div class="scroll-area">
    @for (commodityItem of relatedItems; track commodityItem) {
      <div class="item" [class.external-item-group]="commodityItem.isExternalItemNumberGroup === true">
        @if (commodityItem.isExternalItemNumberGroup) {
          <div class="external-item row">
            <mat-checkbox
              [disabled]="commodityItem.itemNumber === item.itemNumber"
              [(ngModel)]="commodityItem.isSelected"
              [id]="commodityItem.itemNumber"
              (change)="refreshItemsSelected()"
              class="checkbox">
            </mat-checkbox>
            <div class="name">Commodity Code {{ commodityItem.itemNumber }}</div>
          </div>
        }
        @for (i of commodityItem.items; track i) {
          <div class="row" [class.sub-item]="commodityItem.isExternalItemNumberGroup === true">
            <mat-checkbox
              [disabled]="i.commerceItemNumber === item.itemNumber"
              [(ngModel)]="commodityItem.isSelected"
              [id]="i.commerceItemNumber"
              (change)="refreshItemsSelected()"
              class="checkbox"
              [class.invisible]="commodityItem.isExternalItemNumberGroup === true">
            </mat-checkbox>
            <div class="cin">#{{ i.commerceItemNumber }}</div>
            <div class="name">{{ i.itemName }}</div>
            <div class="description">{{ i.itemDescription }}</div>
            <div class="lead-time">{{ i.leadMinutes | leadMinutesFormat }}</div>
            <div class="prep-time">{{ i.prepMinutes | prepMinutesFormat }}</div>
          </div>
        }
      </div>
    }
  </div>
</div>
